import { ActionIcon, Tooltip } from "@mantine/core";
import clsx from "clsx";
import { forwardRef } from "react";

import { useAnalytics } from "@/analytics";

import type { IconButtonProps } from "./types";

import styles from "./IconButton.module.css";

const IconButtonWrapper = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButtonWrapper(
    // oxlint-disable-next-line no-unused-vars
    { active, tooltip, ...rest }: IconButtonProps,
    ref,
) {
    return <ActionIcon {...rest} ref={ref} />;
});

export function IconButton(props: IconButtonProps) {
    const { dispatcher } = useAnalytics();
    const { actionId, extraContext, eventData } = props.analytics;
    const enhancedDispatcher = extraContext ? dispatcher.withExtra(extraContext) : dispatcher;

    function onClick(event: React.MouseEvent<HTMLButtonElement>) {
        void enhancedDispatcher.dispatchAction("ButtonClick", actionId, { ...eventData });
        props.onClick?.(event);
    }

    const handleWrapperEnter = () => {
        void enhancedDispatcher.dispatchAction("KeypressEnter", actionId, eventData);
    };

    return (
        <Tooltip label={props.tooltip} position="bottom" zIndex={999}>
            <IconButtonWrapper
                {...props}
                // Merged, not replaced: Mantine's Popover.Target clones its child with a className,
                // which otherwise dropped this and fell through to ActionIcon's filled variant.
                className={clsx(props.active ? styles.iconButtonActive : styles.iconButtonRoot, props.className)}
                onClick={onClick}
                onKeyUp={(e) => e.key === "Enter" && handleWrapperEnter}
            >
                {props.children}
            </IconButtonWrapper>
        </Tooltip>
    );
}
